import { render, staticRenderFns } from "./StudentFamilyForm.vue?vue&type=template&id=5df0c469&scoped=true"
import script from "./StudentFamilyForm.vue?vue&type=script&lang=js"
export * from "./StudentFamilyForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df0c469",
  null
  
)

export default component.exports